import {GoBackIcon} from './GoBackIcon';
import {IndexNumber} from './IndexNumber';
import {InfoIcon} from './InfoIcon';
import {Label} from './Label';
import {Wrapper} from './Wrapper';

export const ChapterMenu = {
  Label,
  Wrapper,
  InfoIcon,
  GoBackIcon,
  IndexNumber,
};
